<template>
	<div class="sidebar" :class="{ open: isOpen, close: !isOpen }">
		<div class="sidebar__content sidebar__content--env">
			<MenuLogo class="sidebar__logo" v-if="isOpen" />
			<ClosedMenuLogo class="sidebar__logo" v-else />
			<MenuContent :class="!isOpen ? 'sidebar__padding' : ''" />
		</div>
		<div class="sidebar__arrow sidebar__arrow--env" @click="openMenu">
			<SidebarArrow />
		</div>
	</div>
</template>

<script>
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import MenuLogo from '@/components/shared/Icons/MenuLogo.vue';
import ClosedMenuLogo from '@/components/shared/Icons/ClosedMenuLogo.vue';
import MenuContent from '@/components/shared/MenuContent/MenuContent.vue';

export default {
	name: 'Sidebar',
	components: {
		SidebarArrow,
		MenuLogo,
		ClosedMenuLogo,
		MenuContent,
	},
	data: () => ({
		isOpen: true,
	}),
	mounted() {},
	methods: {
		openMenu() {
			this.isOpen = !this.isOpen;
			this.$emit('handleWebSidebar');
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'Sidebar.scss';
</style>
